<template>
    <b-container fluid id="tables">
      <b-row
        style="display: flex; justify-content: space-between; width: 100%; text-align: center; padding: 10px;"
      >
        <div class="col-3">
          <input
            class="form-control ShifokrSverka"
            type="date"
            v-model="datas.datetime1"
          />
        </div>
        <div class="col-3">
          <input
            class="form-control ShifokrSverka"
            type="date"
            v-model="datas.datetime2"
          />
        </div>
        <div>
          <button
            type="button"
            class="btn text-white"
            style="background: #195FB0; width: 130px; font-size: 14px"
            @click="Send"
          >
            <img
              src="../../../public/Vector.png"
              alt=""
              style="margin-right: 5px"
            />
            {{ "Кўриш" }}
          </button>
        </div>
      </b-row>
      <div>
        <div class="tablesD">
          <table class="table  table-bordered table-sm table-striped">
            <tr class="bg-dark text-white">
              <th style="width: 30px !important">#</th>
              <th>{{ "Ф.И.Ш" }}</th>
              <th>{{ "Вақт" }}</th>
              <th>{{ "Шифокор сумма" }}</th>
              <th>{{ "Жами сумма" }}</th>
            </tr>
            <tr
              v-for="(item, index) in results"
              :key="index"
              v-on:dblclick="Router(item)"
            >
              <td>{{ index + 1 }}</td>
              <td>{{ item.patient.fullname }}</td>
              <td>{{ item.date_time | dateFormatDD }}</td>
              <td>{{ item.price | numFormat }}</td>
              <td>{{ item.summa | numFormat }}</td>
            </tr>
            <tr>
              <td colspan="3">{{ "Жами" }}</td>
              <td>{{ jami.jami_sum | numFormat }}</td>
              <td>{{ jami.jami_pay_summa | numFormat }}</td>
            </tr>
          </table>
        </div>
      </div>
    </b-container>
  </template>
  
  <script>
  import moment from "moment";
  export default {
    data() {
      return {
        datas: {
          datetime1: new Date().toISOString().slice(0, 10),
          datetime2: new Date().toISOString().slice(0, 10)
        },
        jami: {
          jami_pay_summa: 0,
          jami_sum: 0
        },
        results: [],
        localUser: JSON.parse(localStorage.getItem("user"))
      };
    },
    filters: {
      dateFormatDD: function(date) {
        if (date) {
          return moment.unix(date).format("DD.MM.YYYY HH:mm");
        } else {
          return "";
        }
      }
    },
    created() {
      
    },
  
    methods: {
      Send() {
        this.jami = {
          jami_pay_summa: 0,
          jami_sum: 0
        }
        let self = this;
        var datas = {
        datetime1: parseInt(
            new Date(self.datas.datetime1)
              .valueOf()
              .toString()
              .slice(0, 10)
          ),
          datetime2:
            parseInt(
              new Date(self.datas.datetime2)
                .valueOf()
                .toString()
                .slice(0, 10)
            ) + 86399
        };
        axios({
          method: "post",
          url: "registration/imtiyozlilar",
          data: datas
        }).then((res) => {
          if (res) {
            self.results = res.data.data.data
            self.jami = res.data.data.all_summa
          }
        });
      },
      Router(item) {
        let route = this.$router.resolve({
          path: "/arxivone/" + item.doc_id
        });
        window.open(route.href, "_blank");
      }
    },
    mounted() {
      // this.getKassa();
    }
  };
  </script>
  
  <style scoped>
  .reds {
    color: red;
  }
  .tablesD {
    /* overflow-y: scroll; */
    /* overflow-x: hidden; */
    /* height: 395px; */
    width: 100%;
  }
  #y1 {
    width: 80px !important;
  }
  table {
    margin: 0px;
  }
  label,
  td,
  th,
  tr {
    font-family: "Times New Roman", Times, serif;
    font-weight: bolder;
    text-transform: capitalize;
    font-size: 15px;
    height: 30px !important;
  }
  .ShifokrSverka {
    border-radius: 3px;
    background: #fff;
    border: 1px solid rgb(210, 210, 210);
  }
  .reds {
    color: red;
  }
  #tables {
    text-align: center;
    width: 99% !important;
    height: 100vh !important;
  }
  th {
    color: #195fb0;
    background-color: #f4f7fb;
  }
  </style>
  